<template>
  <div class="landing-wrapper">
    <div class="cont-outer cont-outer-cont-1">
      <div class="container-landing cont-1 landing-cont">
        <div class="inner-outer-wrapper">
          <div class="bottles-div">
            <div class="bottle-1-outer">
              <div class="bottle-1">
                <div class="shxefi">
                  <img
                    src="/img/shxefebi/0.png"
                    alt=""
                    class="drops"
                    ref="shxefianim"
                  />
                </div>
                <img
                  src="@/assets/img/bottle1new.png"
                  class="bottleitself"
                  alt=""
                  v-if="locale == 'ge'"
                />

                   <img
                  src="@/assets/img/bottle1neweng.png"
                  class="bottleitself"
                  alt=""
                  v-else
                />
              </div>
            </div>

            <img src="@/assets/img/bottle2new.png" class="bottle-2"  v-if="locale == 'ge'" alt="" />
            <img src="@/assets/img/bottle2new.eng.png" class="bottle-2" v-else alt="" />
          </div>
          <div class="inner-inner-wrapper">
            <div class="red-circles-bg">
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
              <div class="circle"></div>
            </div>
            <div class="text-bg lg-only">
              <div class="left-wing">
                <h2 class="f-50 regular">{{ $fn.tr("არც ისე წყნარი და") }}</h2>
                <img src="@/assets/img/left-wing.png" alt="" />
              </div>
              <div class="right-wing">
                <h2 class="f-50 regular">
                  {{ $fn.tr("არც ბოლომდე ცქრიალა") }}
                </h2>
                <img src="@/assets/img/right-wing.png" alt="" />
              </div>
            </div>
            <div class="text-bg sm-only">
              <div class="left-wing">
                <h2 class="f-50 regular">{{ $fn.tr("არც ისე წყნარი და") }}</h2>
                <img src="@/assets/img/leftwingsm.png" alt="" />
              </div>
              <div class="right-wing">
                <h2 class="f-50 regular">
                  {{ $fn.tr("არც ბოლომდე ცქრიალა") }}
                </h2>
                <img src="@/assets/img/rightwingsm.png" alt="" />
              </div>
            </div>
            <div class="hover-wrapper">
              <div class="shop-btn pointer">
                <div class="inner-mask"></div>

                <div class="icon arrow arrowAnim">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25.221"
                    height="47.845"
                    viewBox="0 0 25.221 47.845"
                  >
                    <g
                      id="Group_507"
                      data-name="Group 507"
                      transform="translate(-930.868 -2524.458)"
                    >
                      <g
                        id="Group_506"
                        data-name="Group 506"
                        transform="translate(955.039 2540.753) rotate(90)"
                      >
                        <g id="menu" transform="translate(0 0)">
                          <g
                            id="Group_103"
                            data-name="Group 103"
                            transform="translate(0 0)"
                          >
                            <path
                              id="Union_6"
                              data-name="Union 6"
                              d="M14.265,18.651a58.664,58.664,0,0,1,7.447-5.2,23.889,23.889,0,0,1,2.682-1.4c-.124-.037-.246-.076-.364-.117a49.545,49.545,0,0,0-8.7-.416c-1.748.017-3.478.034-5.126-.053-7.126-.381-14.169-1.385-21.328-1.421-2.464-.013-6.46-2.564-2.288-2.543C-5.3,7.543,2.644,8.764,10.733,9.02c4.946.157,10.342-.219,15.157.844.091.02.183.041.276.064C23.528,7.2,20.553,4.794,18.3,1.706,17.6.754,18.154-.806,19.107.5c2.79,3.823,6.7,6.609,9.694,10.262.507.618.432,1.5.023,1.653a1.434,1.434,0,0,1-.941.424c-2.147.143-4.13,1.376-5.9,2.52a65.656,65.656,0,0,0-6.131,4.375,1.417,1.417,0,0,1-.9.3C14.115,20.034,13.35,19.406,14.265,18.651Z"
                              transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.054)"
                              fill="#044b30"
                              stroke="#044b30"
                              stroke-width="2"
                            />
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cont-outer cont-outer-cont-2">
      <div class="container-landing cont-2 landing-cont" data-scroll>
        <img
          src="@/assets/img/bottle2new.png"
          class="bottleitself sm-only"
          alt=""
          v-if="locale == 'ge'"
        />
           <img
          src="@/assets/img/bottle2new.eng.png"
          class="bottleitself sm-only"
          alt=""
          v-else
        />
        <div class="pyramid-wrapper">
          <img
            src="@/assets/img/triangle.png"
            alt=""
            v-for="(p, index) in 48"
            :key="index"
          />
        </div>
        <div class="inner-outer-wrapper">
          
          <div class="text-block">
            <!-- <div
              class="b-desc"
              v-html="this.bottleContent[0].description"
            ></div> -->
            <div class="ttl-wrapper">
            <!-- <h2 class="f-55">{{ $fn.tr("ჟუჟუნა") }}</h2> -->
            <h2 class="f-55">{{_.get(contentData, 'conf.header.title')}}</h2>
          </div>
            <p class="b-desc">{{_.get(contentData, 'conf.header.teaser')}}</p>
            <div class="low-col">
              <!-- <router-link
                :to="
                  getShopLink +
                    '/singleview/' +
                    this.bottleContent[0].id +
                    '-' +
                    this.bottleContent[0].slug
                "
                class="buy-btn"
              >
                <div class="inner-mask"></div>
                <h2 v-if="$route.name === 'ge'">
                  <span class="regular f-30">შ</span>
                  <span class="regular f-30">ე</span>
                  <span class="regular f-30">ძ</span>
                  <span class="regular f-30">ე</span>
                  <span class="regular f-30">ნ</span>
                  <span class="regular f-30">ა</span>
                </h2>

                <h2 v-if="$route.name === 'en'">
                  <span class="regular f-30">b</span>
                  <span class="regular f-30">u</span>
                  <span class="regular f-30">y</span>
                </h2>
              </router-link> -->
              <router-link :to="getAboutLink" class="read-more">
                <div class="inner-wrapper">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31.675"
                    height="22.988"
                    viewBox="0 0 31.675 22.988"
                  >
                    <g
                      id="Group_104"
                      data-name="Group 104"
                      transform="translate(25.293 -3.205)"
                    >
                      <g id="menu" transform="translate(-24.754 3.74)">
                        <g
                          id="Group_103"
                          data-name="Group 103"
                          transform="translate(0 0)"
                        >
                          <path
                            id="Union_6"
                            data-name="Union 6"
                            d="M14.188,18.549a58.283,58.283,0,0,1,7.4-5.171c.715-.424,1.448-.829,2.2-1.182-1.091-.045-2.205,0-3.308.045-1.171.049-2.329.094-3.434.039-4.772-.258-9.5-1.134-14.285-1.043-1.647.027-4.351-2.44-1.56-2.492,5.429-.1,10.753.977,16.168,1.092.9.017,1.815,0,2.742-.025a29.737,29.737,0,0,1,6.123.291C23.565,7.291,20.5,4.854,18.2,1.7c-.692-.945-.142-2.5.8-1.2,2.773,3.807,6.667,6.576,9.641,10.209a1.562,1.562,0,0,1,.248.424,1.243,1.243,0,0,1,.392.951c0,.042,0,.081,0,.118-.024.716-1.047.863-2.069.626a14.12,14.12,0,0,0-5.341,2.45,65.534,65.534,0,0,0-6.1,4.352,1.4,1.4,0,0,1-.9.3C14.039,19.925,13.278,19.3,14.188,18.549Z"
                            transform="matrix(0.998, -0.07, 0.07, 0.998, 0, 2.043)"
                            fill="#044b30"
                            stroke="#044b30"
                            stroke-width="1"
                          />
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span class="f-30">{{ $fn.tr("გაიგე მეტი") }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["contentData"],
  components: {},
  data() {
    return {
      totalFrames: 21,
      totalFrames2: 7,
      totalFrames3: 7,

      imagePath: "/img/shxefebi",
      imagePath2: "/img/rotation",
      imagePath3: "/img/shake",

      frameNumber: 0
    };
  },

  watch: {
    ageVer: function(newState, oldState) {
      if ((newState = true)) {
        setTimeout(() => {
          document.querySelector("body").classList.add("loaded");
          document.querySelector("body").classList.add("landing-wrapper");
        }, window.innerWidth >= 768 ? 60 : 700);
        setTimeout(() => {
          document.querySelector("body").classList.add("loaded-ready");
        }, window.innerWidth >= 768 ? 1000 : 1700);
      }
    }
  },
  mounted() {
    document.querySelector("body").classList.add("landing-wrapper");
    if (localStorage.getItem('ageVerified')) {
      setTimeout(() => {
        document.querySelector("body").classList.add("loaded");
      }, window.innerWidth >= 768 ? 60 : 700);
      setTimeout(() => {
        document.querySelector("body").classList.add("loaded-ready");
      }, window.innerWidth >= 768 ? 1000 : 1700);
    }

    if (window.innerWidth >= 1024) {
      // for (let i = 0; i < this.totalFrames; i++) {
      //   let preload = `<div id="preload-image-${i}" style="background-image: url('${this.imagePath}/${i}.png');"></div>`;
      //   document.body.insertAdjacentHTML("beforeend", preload);
      // }
      // for (let i = 0; i < this.totalFrames2; i++) {
      //   let preload = `<div id="preload-image-${i}" style="background-image: url('${this.imagePath2}/${i}.png');"></div>`;
      //   document.body.insertAdjacentHTML("beforeend", preload);
      // }
      for (let i = 0; i < this.totalFrames3; i++) {
        let preload = `<div id="preload-image-${i}" style="background-image: url('${this.imagePath3}/${i}.png');"></div>`;
        document.body.insertAdjacentHTML("beforeend", preload);
      }
    }
  },

  computed: {
    locale(){
      return this.$store.state.main.locale;
    },
    getAboutLink() {
      let _m = this.$store.state.main.indx.menus;
      let dup = [..._m];
      dup = dup.filter(m => m.configs.includes("about"));
      return dup[0].full_url;
    },
    getShopLink() {
      let _m = this.$store.state.main.indx.menus;
      let dup = [..._m];
      dup = dup.filter(m => m.configs.includes("shop"));
      return dup[0].full_url;
    },
    bottleContent() {
      let _list = _.get(this.contentData, "data.list");
      let dup = [];
      let __attr = this.$store.state.main.indx.attributes.products_category;
      for (let i = 0; i < _list.length; i++) {
        let _attr = _list[i].allAttributes;
        for (let j = 0; j < __attr.length; j++) {
          for (let k = 0; k < _attr.length; k++) {
            if (_attr[k] == __attr[j].id) {
              if (__attr[j].slug != "cocktails") dup.push(_list[i]);
            }
          }
        }
      }

      return dup;
    },

    ageVer() {
      return this.$store.state.main.ageVerified;
    }
  },
  updated() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.landing-wrapper.loaded-ready .shop-btn {
  pointer-events: none;
}
</style>
